import { LogoContainer, LogoImage } from './styled'
import { RenderIf } from 'components/RenderIf'
import { LogoPlaceholder } from './PlaceholderImages'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

export const Logo = () => {
  const logoImage = useMySelector(
    (state) => state.app.interfaceStyles.logoImage
  )

  return (
    <LogoContainer>
      {/* We don't need to display any logos when the logo is not loaded by customer*/}
      {/* <RenderIf condition={!logoImage}>
        <LogoPlaceholder />
      </RenderIf> */}
      <RenderIf condition={!!logoImage}>
        <LogoImage src={logoImage} alt="Logo" height="316.5" width="316.5" />
      </RenderIf>
    </LogoContainer>
  )
}
